
import Wallet1 from "../../../assets/outline/Wallet1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Wallet1Icon({ className, dataTestid = "Wallet1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Wallet1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
